module.exports = __webpack_public_path__ + "static/media/2052f8eb.jpg";